module.exports = __webpack_public_path__ + "img/default.cf7e7610.jpg";